import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Button from 'components/Button';
import Paragraph from 'components/Paragraph';
import { Form } from 'libs/forms';
import AddressCard from 'apps/addresses/blocks/AddressCard';

import { ModalTitle } from 'legacyComponents/styled/lib';
import { ModalContent } from 'apps/modals/styles';
import {
  AddressModalWrapper,
  AddressCardsWrapper,
  ActionsRowWrapper,
  FormWrapper,
} from 'apps/addresses/blocks/AddressModal.styles';

const AddressModal = props => {
  const { t, manager, description } = props;
  const { addingAddress } = manager;
  const formRef = useRef(null);

  useEffect(() => {
    setTimeout(() => props?.fadeIn(), 300);
  }, []);

  useEffect(() => {
    // Scroll into AddressForm
    if (addingAddress) {
      formRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [addingAddress, formRef]);

  const addressCards = manager?.addresses.map(address => (
    <AddressCard
      key={address?.id}
      selected={manager?.fieldStore?.value?.id === address?.id}
      address={address}
      MakeDefault={manager?.MakeDefault}
      ShipTo={manager?.ShipTo}
      StartDelete={manager?.StartDelete}
      deleting={manager?.deleting}
      Delete={manager?.Delete}
      CancelDelete={manager?.CancelDelete}
    />
  ));

  return (
    <AddressModalWrapper>
      <ModalTitle>{t('Delivery Addresses')}</ModalTitle>
      {description && <Paragraph>{description}</Paragraph>}
      <ModalContent>
        {manager?.addingAddress ? (
          <FormWrapper ref={formRef}>
            <Form
              noBorder
              padding='0'
              formTitle='Add Delivery Address'
              formStore={manager?.addAddressFormStore}
              buttonHandler={manager?.AddAddress}
              actionProps={{
                outline: true,
              }}
            />
          </FormWrapper>
        ) : (
          <ActionsRowWrapper>
            <Button
              outline
              size='small'
              variant='tertiary'
              icon='add'
              margin='0 1rem 2rem 1rem'
              text-id='add-delivery-address-btn'
              text={t('Add New Delivery Address')}
              onClick={manager?.OpenAddAddress}
            />
          </ActionsRowWrapper>
        )}
        {manager?.changingAddress && (
          <AddressCardsWrapper>{addressCards}</AddressCardsWrapper>
        )}
      </ModalContent>
    </AddressModalWrapper>
  );
};

AddressModal.propTypes = {
  t: PropTypes.func,
  fadeIn: PropTypes.func,
  manager: PropTypes.object,
  description: PropTypes.string,
};

export default withNamespaces()(observer(AddressModal));
